<template>
  <div id="home-container">
    <div class="home">
      <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
      <div class="column is-full logo-title">
        <img v-if="logoBase64Src != null" :src="logoBase64Src" class="center" v-show="logo">
      </div>
      <!-- <div class="level-right">
      <b-field class="page-title" expanded>
      <b-input placeholder="Search..." v-model="search" type="search"></b-input><p class="control"><button class="button is-static"><i class="fa fa-search"></i></button></p>
      </b-field>
      </div> -->
      <div class="card-container filter">
        <div :class="collapseClass">
          <p class="subtitle is-5">Filter</p>
          <button @click="collapseComponent()" class="collapse-button float-right">
          <b-icon :icon="collapseIcon"></b-icon>
          </button>
        </div>
        <div class="filter-form" v-show="!isCollapsed">
          <!--FILTER CONTAINER-->
          <div class="columns">
             <!--TOPIC FILTER-->
            <div class="filter-object column is-one-fifth">
              <p>Topic</p>
              <b-field>
              <b-select expanded class="filter-select" v-model="filterObject.topic" @input="loadFilteredPackages">
                <option v-for="option in topicFilterArray" :value="option" :key="option">{{option}}</option>
              </b-select>
              <button class="control button is-text clear-filter-button" @click="clearFilter('topic')">
                <p>X</p>
              </button>
              </b-field>
            </div>
            <!--TYPE FILTER-->
            <div class="filter-object column is-one-fifth">
              <p>Resource Type</p>
              <b-field>
              <b-select expanded class="filter-select" v-model="filterObject.type" @input="loadFilteredPackages">
                <option v-for="option in typeFilterArray" :value="option" :key="option">{{option}}</option>
              </b-select>
              <button class="control button is-text clear-filter-button" @click="clearFilter('type')">
                <p>X</p>
              </button>
              </b-field>
            </div>
            <!--LEVEL FILTER-->
            <div class="filter-object column is-one-fifth">
              <p>Level</p>
              <b-field>
              <b-select expanded class="filter-select" v-model="filterObject.level" @input="loadFilteredPackages">
              <option v-for="option in levelFilterArray" :value="option" :key="option">{{option}}</option>
              </b-select>
              <button class="control button is-text clear-filter-button" @click="clearFilter('level')">
              <p>X</p>
              </button>
              </b-field>
            </div>
            <!--GRADE FILTER-->
            <div class="filter-object column is-one-fifth">
              <p>Grade</p>
              <b-field>
              <b-select expanded class="filter-select" v-model="filterObject.grade" @input="loadFilteredPackages">
                <option v-for="option in gradeFilterArray" :value="option" :key="option">{{option}}</option>
              </b-select>
              <button class="control button is-text clear-filter-button" @click="clearFilter('grade')">
                <p>X</p>
              </button>
              </b-field>
            </div>
            <!--CLEAR ALL BUTTON-->
            <div class="filter-object column is-one-fifth clear-filter">
              <button class="button is-text float-right" @click="clearAllFilters()">Clear All</button>
            </div>
          </div>
        </div>
      </div>
      <!--NO RESULTS-->
      <div class="card-container no-results" v-show="showNoResults">
        <p class="subtitle is-5">No Documents Found</p>
      </div>
      <!--CONTENT GRID-->
      <div class="content-grid-container">
        <document-grid class="results" v-for="_document in searchResults" v-bind:key="_document.digitalPackageDocumentID" :_document="_document"></document-grid>
      </div>
    </div>
    <copyright-footer></copyright-footer>
  </div>
</template>

<script>
import DocumentGrid from '@/components/DocumentGrid.vue'
import CopyrightFooter from '@/components/CopyrightFooter.vue'
import userAPI from '@/api/UserAPI.js'
import sharedAPI from '@/api/SharedAPI.js'
import store from '../store.js'
import { mapGetters } from 'vuex'
import { mapMutations, mapState } from 'vuex'



export default {
  name: 'home',
  
  components:{
    "document-grid": DocumentGrid,
    "copyright-footer": CopyrightFooter
  },

  data () {
    return{
       documentsArray: [],
      //  gradeFilter: "",
      //  topicFilter: "",
      //  typeFilter: "",
       filterArray: [null, null, null, null],
       filterObject: {
         grade: null,
         topic: null,
         level: null,
         type: null
       },
       gradeFilterArray: [],
       topicFilterArray: [],
       typeFilterArray: [],
       levelFilterArray: [],
       search: "",
       isLoading: false,
       isFullPage: true,
       isCollapsed: false,
       re: null,
       notificationDuration: 5000,
       offset: 0,
       foundCount: 0,
    }
  },

  created(){
    this.loadPackages()
    this.loadFilterObjects()
    this.loadExpirationDate()
  },

  mounted(){
    this.scroll()
  },

  computed: {
     ...mapState([
      'userInfo',
      'documents',
      'slug',
      'logo',
      'linkExpirationDate'
    ]),


    searchResults: function(){
      return this.documents
    },


    showNoResults: function(){
      if (this.isLoading == false){
        return !this.searchResults.length
      }  
    },


    collapseIcon: function(){
      if(this.isCollapsed == false){
        return "chevron-up"
      }
      else{
        return "chevron-down"
      }
    },


    collapseClass: function(){
      if(this.isCollapsed == false){
        return "filter-title-not-collapsed"
      }
      else{
        return "filter-title-collapsed"
      }
    },


    emptyFilterArray: function(){
       return this.filterArray.every( selectedFilter =>{
        if(!selectedFilter){
          return true
        }
        else{
          return false
        }
        
      }
     )
    },


    logoBase64Src: function(){
      if (this.logo !="" && this.logo != null && this.logo !=undefined && Object.keys(this.logo).length != 0){
          return "data:image/jpg;base64, " + this.logo
      }
      else{
        return null
      }
    }


  },

  methods: {
    ...mapMutations([
      'setDocuments',
      'setLinkExpirationDate'
    ]),

    /**
     * TOGGLES COLLAPSABLE FILTER COMPONENT
     */
    collapseComponent: function(){
      this.isCollapsed = !this.isCollapsed
    },


    /**
     * CLEARS ALL FILTER VALUES
     */
    clearAllFilters: function(){
      if(this.filterObject.type == null && this.filterObject.topic == null && this.filterObject.level == null && this.filterObject.grade == null){
        return
      }
      this.filterObject.topic = null
      this.filterObject.type = null
      this.filterObject.level = null
      this.filterObject.grade = null
      //clear out documents before the query
      this.documentsArray = [];
      store.commit('setDocuments', [])
      this.loadPackages();
    },


    /**
     * CLEAR SPECIFIC FILTER
     */
    clearFilter: function(key){
      this.filterObject[key] = null
      if(this.filterObject.type != null || this.filterObject.topic != null || this.filterObject.level != null || this.filterObject.grade != null){
        this.loadFilteredPackages();
      }
      else{
        //clear out documents before the query
        this.documentsArray = [];
        store.commit('setDocuments', [])
        this.loadPackages();
      }
    },  


    /**
     * FORMATS DATA RECIEVED FROM FILEMAKER
     */
    formatData: function(response){
      var self = this
      var digitalPackageDocuments = response.response.data
      var documentTO = "digital_package_document__DOCUMENT__documentID::"
      var packageTO = "digital_package_document__DIGITAL_PACKAGE__digitalPackageID::"

      //GOES THROUGH EACH RECORD AND CREATE AN OBJECT
      // digitalPackageDocuments.sort((a,b)=>{return a.fieldData.sort - b.fieldData.sort})
      digitalPackageDocuments.forEach(function(digitalPackageDocument){
        var digitalPackageDocumentId = digitalPackageDocument.fieldData['__kptID']
        var documentID = digitalPackageDocument.fieldData['_kftDocumentID']
        var digitalPackageID = digitalPackageDocument.fieldData['_kftDigitalPackageID']
        var description = digitalPackageDocument.fieldData[documentTO + 'description']
        var fileExtension = digitalPackageDocument.fieldData[documentTO + 'fileExt']
        var fileName = digitalPackageDocument.fieldData[documentTO + 'zctFileNameContainer']
        var filePath = digitalPackageDocument.fieldData[documentTO + 'ftpPath']
        var documentPackageName = digitalPackageDocument.fieldData[packageTO + 'name']
        var documentPackageSearchTerms = digitalPackageDocument.fieldData[ 'zctSearchTerms']
        var base64Thumbnail = digitalPackageDocument.fieldData[documentTO + 'zctBase64EncodedThumbnail']
        var isDownloadable = digitalPackageDocument.fieldData[documentTO + 'isDownloadable']
        var isPrintable = digitalPackageDocument.fieldData[documentTO + 'isPrintable']
        var documentType = digitalPackageDocument.fieldData[documentTO + 'productType']
        var thumbnailPath = digitalPackageDocument.fieldData[documentTO + 'thumbnailFTPpath']
        var singularProductType = digitalPackageDocument.fieldData[documentTO + 'zctSingularProductType']

        self.documentsArray.push({
          'digitalPackageDocumentID': digitalPackageDocumentId,
          'ID': documentID,
          'packageID': digitalPackageID,
          'title': description,
          'fileExt': fileExtension,
          'fileName': fileName,
          'filePath': filePath,
          'packageName': documentPackageName,
          'searchTerms': documentPackageSearchTerms,
          'base64Thumbnail': base64Thumbnail,
          'isDownloadable': isDownloadable,
          'isPrintable': isPrintable,
          'documentType': documentType,
          'thumbnailPath': thumbnailPath,
          'singularProductType': singularProductType
        })
      })
    },


    /**
     * LOADS IN THE VALUES FOR FILTERS FROM FILEMAKER
     */
    loadFilterObjects: async function(){
      var valueLists
      var scriptResult
      valueLists = await sharedAPI.loadFilterObjects()

      if(valueLists.messages[0].code =="401" || valueLists.messages[0].code == "Operation timed out after 30000 milliseconds with 0 bytes received"){
        this.$router.replace( { name: "login" } )
        this.$snotify.error( valueLists.messages[0].message + ". Session most likely ended. Please contact Woodburn is issue persists.", "Error",
            {
                showProgressBar: false,
                position: 'rightBottom',
                icon: false,
                timeout: this.notificationDuration,
                closeOnClick: true,
                bodyMaxLength: 1000
            }
        )
        return
      }

      if(valueLists.messages[0].code != "0"){
        this.$snotify.error( valueLists.messages[0].message + ". Session most likely ended. Please log out and try again.", "Error",
            {
                showProgressBar: false,
                position: 'rightBottom',
                icon: false,
                timeout: this.notificationDuration,
                closeOnClick: true,
                bodyMaxLength: 1000
            }
        )
      return
      }

      scriptResult = JSON.parse(valueLists.response.scriptResult)
      this.gradeFilterArray = scriptResult.grade
      this.topicFilterArray = scriptResult.topic
      this.typeFilterArray = scriptResult.type
      this.levelFilterArray = scriptResult.level
    },


    /**
     * LOADS IN THE EXPIRATION DATE GIVEN TO THE ACCOUNT FOR SHARE LINKS
     */
    loadExpirationDate: async function(){
      var findResults = await sharedAPI.loadExpirationDate();
      var exDate = findResults.response.data[0].fieldData.defaultWoodburnPlusSharingLinkExpirationDate;
      store.commit('setLinkExpirationDate', exDate)

    },

    /**
     * LOAD PACKAGES BASED ON THE FILTER OBJECT
     */
    loadFilteredPackages: async function(){
      this.isLoading = true
      try{
        var findResults
        var accountID = this.userInfo.accountID
        var params = {
          "accountID": accountID, 
          "topic": this.filterObject.topic,
          "type": this.filterObject.type,
          "grade": this.filterObject.grade,
          "level": this.filterObject.level
        }
        JSON.stringify(params)
        findResults = await userAPI.loadPackages(params)

        if(findResults.messages[0].code != 0){
          throw findResults
        }

        this.documentsArray = []
        this.offset = 0
        var foundCount = findResults.response.dataInfo.foundCount;
        this.foundCount = foundCount
        this.formatData(findResults)
        store.commit('setDocuments', this.documentsArray)

      }
      catch(e){
        console.log(e)        
        if(e.messages[0].code == 401){
          console.log('caught in line 422')
          store.commit('setDocuments', [])
          this.isLoading = false
        }
        else if(e.messages[0].code == undefined || e.messages[0].code == "Operation timed out after 30000 milliseconds with 0 bytes received"){
          this.$router.replace({name:"login"})
          this.$snotify.error( findResults.messages[0].message + ". Session most likely ended. Please login and try again. Please contact Woodburn is issue persists.", "Error",
              {
                  showProgressBar: false,
                  position: 'rightBottom',
                  icon: false,
                  timeout: this.notificationDuration,
                  closeOnClick: true,
                  bodyMaxLength: 1000
              }
            )
        }
        else{
          this.$router.replace({name:"login"})
          this.$snotify.error( findResults.messages[0].message + ". Session most likely ended. Please login and try again.", "Error",
              {
                  showProgressBar: false,
                  position: 'rightBottom',
                  icon: false,
                  timeout: this.notificationDuration,
                  closeOnClick: true,
                  bodyMaxLength: 1000
              }
          )
        }
      }
      finally{
        this.isLoading = false
      }
    },


    /**
     * LOADS IN PACKAGES AND THEIR DOCUMENTS FROM FILEMAKER
     */
    loadPackages: async function(){
      this.isLoading = true
      try{
        var findResults
        var accountID = this.userInfo.accountID
        var params = {
          "accountID": accountID, 
          "offset": this.offset,
          "topic": null,
          "type": null,
          "grade": null,
          "level": null
        }
        JSON.stringify(params)
        findResults = await userAPI.loadPackages(params)

        var foundCount = findResults.response.dataInfo.foundCount;
        this.foundCount = foundCount

        if(findResults.messages[0].code != 0){
          throw findResults
        }

        this.formatData(findResults)
        store.commit('setDocuments', this.documentsArray)
      }
      catch(e){
        //Big crazy error trap
        console.log(e)
        if(e.messages[0].code == 401){
          store.commit('setDocuments', [])
          console.log('caught in line 422')
          this.isLoading = false
        }
        else if(e.messages[0].code == undefined || e.messages[0].code == "Operation timed out after 30000 milliseconds with 0 bytes received"){
          this.$router.replace({name:"login"})
          this.$snotify.error( findResults.messages[0].message + ". Session most likely ended. Please login and try again. Please contact Woodburn is issue persists.", "Error",
              {
                  showProgressBar: false,
                  position: 'rightBottom',
                  icon: false,
                  timeout: this.notificationDuration,
                  closeOnClick: true,
                  bodyMaxLength: 1000
              }
            )
        }
        else{
          this.$router.replace({name:"login"})
          this.$snotify.error( findResults.messages[0].message + ". Session most likely ended. Please login and try again.", "Error",
              {
                  showProgressBar: false,
                  position: 'rightBottom',
                  icon: false,
                  timeout: this.notificationDuration,
                  closeOnClick: true,
                  bodyMaxLength: 1000
              }
          )
        }
      }
      finally{
        this.isLoading = false
      }
    },

    //Checks if user scrolled to the bottom of the page
    scroll () {
      window.onscroll = () => {
        let bottomOfWindow = (window.innerHeight + window.pageYOffset) >= document.body.scrollHeight

        if (bottomOfWindow) {
          this.loadMoreData();
        }
     	}
  	},

    // Updates offset and runs loadData again
    async loadMoreData(){
      //Don't Load more if documents are filtered
      if(this.filterObject.type != null || this.filterObject.topic != null || this.filterObject.level != null || this.filterObject.grade != null){
        return
      }
      try{
        var previousOffset = this.offset
        if((this.offset >= this.foundCount - 50) && !this.foundCount == 0){
          this.isLoading = false
          return
        }
        else{  
          this.offset = this.offset + 50;
          await this.loadPackages()
        }
      }
      catch(e){
        console.log(e)
        this.offset = previousOffset;
      }
    }
  }
}


</script>
<style scoped lang="scss">
  .button-column {
    width: 33%;
    float: left;
    padding: 10px;
    justify-content: center;
  }
  .card-container{
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    -moz-box-shadow: none !important;
  }
  .container{
    margin-top: 20px;
  }
  .center {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .clear-filter{
    height: 37px;
    padding: 0px;
  }
  .clear-filter-button{
    text-decoration: none !important;
  }
  .collapse-button{
    background-color: #d3d3d3;
    border: none;
    color: #696969;
    text-align: center;
    text-decoration: none;
    border-radius: 50%;
    padding: 1px;
    float: right;
    outline: none !important;
  }
  .content-grid-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-content: flex-start;
    // justify-content: center;
    // align-items: center;
    width: 100%;
  }
  .filter{
    padding-bottom: 16px !important;
    width: 100%;
    display: inline-block;
    vertical-align: middle;
    margin: 20px 0 !important;
  }
  .filter-object{
    margin: 0% !important;
  }
  .filter-title-collapsed{
    padding-bottom: 0px !important;
    margin-bottom: 0px !important;
  }
  .filter-title-not-collapsed{
    padding-bottom: 35px !important;
    margin-bottom: 10px !important;
  }
  .filter-select{
    flex-grow: 1;
  }
  .filter-select:focus{
    outline:none;
  }
  .float-right{
    float: right;
  }
  .home{
    width: 90%;
    margin-left: auto;
    margin-right: auto;
  }
  .logo-title{
    height: fit-content;
  }
  .no-results{
    padding-bottom: 35px !important;
    width: 100%;
    display: inline-block;
    vertical-align: middle;
    margin: 0px !important;
  }
  .results{
    padding: 0 0 35px 0 !important;
    height: 300px;
    width: 16.6%;
    min-width: 200px;
    display: block;
    background-color: #eeeeee;
    margin: 20px 0px;
  }
  .dummy{
    height: 0px !important;
    padding: 0px !important;
  }
  .subtitle{
    margin: 0% !important;
    padding: 0%;
    height: 0px;
  }
  @media screen and (max-width: 1655px ){
    .results{
      width: 20%;
    }
  }
  @media screen and (max-width: 1340px ){
    .results{
      width: 25%;
    }
  }
  @media screen and (max-width: 1095px ){
    .results{
      width: 33%;
    }
  }
  @media screen and (max-width: 835px ){
    .results{
      width: 50%;
    }
  }
  @media screen and (max-width: 550px ){
    .results{
      width: 100%;
    }
  }
</style>
